import { render, staticRenderFns } from "./ConstraintsPage.vue?vue&type=template&id=df4cb5a4&scoped=true"
import script from "./ConstraintsPage.vue?vue&type=script&lang=js"
export * from "./ConstraintsPage.vue?vue&type=script&lang=js"
import style0 from "./ConstraintsPage.vue?vue&type=style&index=0&id=df4cb5a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df4cb5a4",
  null
  
)

export default component.exports